//
// Images
// --------------------------------------------------

import { css } from "../../styled-components.mjs";
export var imageStyle = function imageStyle() {
  return css(["vertical-align:middle;"]);
};